import type {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  FC,
  PropsWithChildren,
} from "react";
import classNames from "classnames";
import styles from "./ToggleButton.module.scss";

type ToggleButtonProps = { isActive?: boolean } & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export const ToggleButton: FC<PropsWithChildren<ToggleButtonProps>> = (
  props,
) => {
  const { children, isActive = false, ...restProps } = props;

  return (
    <button
      {...restProps}
      className={classNames(
        isActive ? "title-7-bold" : "title-7-medium",
        styles.button,
        isActive && styles.buttonActive,
      )}
    >
      <div
        className={classNames(styles.content, isActive && styles.contentActive)}
      >
        {children}
      </div>
    </button>
  );
};
